//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../ApiService";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/book/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    save: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/book/edit/save", vo, successCallback, failureCallback);
    }
};

export default EditService;